var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEuroTtc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 42,
    viewBox: "0 0 36 42",
    width: 36,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "m21.7167969 2.89355469-1.0253907 4.6875c-.5859374-.26367188-1.875-.703125-3.6621093-.703125-2.8857422 0-4.8632813 1.30371093-5.8447266 3.29589841h8.3789063l-.2490235 1.171875h-8.5693359c-.1904297.6738281-.2783203 1.3916016-.2783203 2.1533203 0 .1904297 0 .366211.0146484.5419922h8.2617188l-.2490235 1.171875h-7.7929687c.6152343 1.9921875 2.4755859 3.1640625 5.9033203 3.1640625.6298828 0 1.7138672-.102539 2.0654297-.2490234l-1.0400391 4.7753906c-.3955078.0878906-1.3330078.234375-2.109375.234375-6.40136718 0-10.48828124-2.9882812-11.07421874-7.9248047h-2.44628906l.24902344-1.171875h2.12402344c0-.0292968 0-.0732422 0-.102539 0-.8935547.07324218-1.7578125.234375-2.5927735h-1.78710938l.24902344-1.171875h1.81640625c1.40625-4.84863279 5.56640621-8.1738281 11.52832031-8.1738281 2.5048828 0 4.6289063.5859375 5.3027344.89355469z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    height: "142.6%",
    width: "145.6%",
    x: "-15.2%",
    y: "-14.2%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowOffsetOuter1",
    result: "shadowMatrixOuter1",
    type: "matrix",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowOffsetOuter2",
    result: "shadowMatrixOuter2",
    type: "matrix",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowOffsetOuter3",
    result: "shadowMatrixOuter3",
    type: "matrix",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter4"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowOffsetOuter4",
    result: "shadowMatrixOuter4",
    type: "matrix",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter5"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowOffsetOuter5",
    result: "shadowMatrixOuter5",
    type: "matrix",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter6"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowOffsetOuter6",
    result: "shadowMatrixOuter6",
    type: "matrix",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: -1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter7"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowOffsetOuter7",
    result: "shadowMatrixOuter7",
    type: "matrix",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter4"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter5"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter6"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter7"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "m3.45703125 8.6015625 1.37695313-6.48632812h2.34960937l.421875-1.96875h-7.18359375l-.421875 1.96875h2.34960938l-1.37695313 6.48632812z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    height: "206.4%",
    width: "218.3%",
    x: "-39.4%",
    y: "-35.5%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowOffsetOuter1",
    result: "shadowMatrixOuter1",
    type: "matrix",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowOffsetOuter2",
    result: "shadowMatrixOuter2",
    type: "matrix",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowOffsetOuter3",
    result: "shadowMatrixOuter3",
    type: "matrix",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter4"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowOffsetOuter4",
    result: "shadowMatrixOuter4",
    type: "matrix",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter5"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowOffsetOuter5",
    result: "shadowMatrixOuter5",
    type: "matrix",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter6"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowOffsetOuter6",
    result: "shadowMatrixOuter6",
    type: "matrix",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: -1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter7"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowOffsetOuter7",
    result: "shadowMatrixOuter7",
    type: "matrix",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter4"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter5"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter6"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter7"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "m11.109375 8.6015625 1.3769531-6.48632812h2.3496094l.421875-1.96875h-7.18359375l-.421875 1.96875h2.34960935l-1.3769531 6.48632812z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "f",
    height: "206.4%",
    width: "218.3%",
    x: "-39.4%",
    y: "-35.5%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowOffsetOuter1",
    result: "shadowMatrixOuter1",
    type: "matrix",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowOffsetOuter2",
    result: "shadowMatrixOuter2",
    type: "matrix",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowOffsetOuter3",
    result: "shadowMatrixOuter3",
    type: "matrix",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter4"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowOffsetOuter4",
    result: "shadowMatrixOuter4",
    type: "matrix",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter5"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowOffsetOuter5",
    result: "shadowMatrixOuter5",
    type: "matrix",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter6"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowOffsetOuter6",
    result: "shadowMatrixOuter6",
    type: "matrix",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: -1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter7"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowOffsetOuter7",
    result: "shadowMatrixOuter7",
    type: "matrix",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter4"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter5"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter6"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter7"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "m20.7421875 3.55078125h2.4082031c.0175782-.09375.0292969-.22851563.0292969-.375 0-1.84570313-1.4765625-3.17578125-3.5214844-3.17578125-3.0117187 0-4.9394531 2.03320312-4.9394531 5.203125 0 2.15039062 1.4765625 3.54492188 3.7441406 3.54492188 2.2851563 0 4.0195313-1.359375 4.3125-3.38085938h-2.4082031c-.2460937.83789063-.9082031 1.359375-1.7285156 1.359375-.84375 0-1.359375-.63867188-1.359375-1.67578125 0-1.78710937.8789062-3.05273437 2.1210937-3.05273437.7617188 0 1.3476563.57421874 1.3476563 1.31835937 0 .17578125 0 .19921875-.0058594.234375z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "h",
    height: "202.9%",
    width: "206.4%",
    x: "-35.5%",
    y: "-34.3%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowOffsetOuter1",
    result: "shadowMatrixOuter1",
    type: "matrix",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowOffsetOuter2",
    result: "shadowMatrixOuter2",
    type: "matrix",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowOffsetOuter3",
    result: "shadowMatrixOuter3",
    type: "matrix",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter4"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowOffsetOuter4",
    result: "shadowMatrixOuter4",
    type: "matrix",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter5"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowOffsetOuter5",
    result: "shadowMatrixOuter5",
    type: "matrix",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter6"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowOffsetOuter6",
    result: "shadowMatrixOuter6",
    type: "matrix",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: -1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter7"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowOffsetOuter7",
    result: "shadowMatrixOuter7",
    type: "matrix",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter4"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter5"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter6"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter7"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#b)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#e00017",
    fillRule: "evenodd",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(7.594727 28.536133)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#d)",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#e00017",
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#f)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#e00017",
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#h)",
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#e00017",
    xlinkHref: "#g"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuroTtc);
export default __webpack_public_path__ + "static/media/euro_ttc.b1b6fbffe1171dd898060b8003035498.svg";
export { ForwardRef as ReactComponent };